export default function () {
    const imageComponents = document.querySelectorAll('.c-media');

    for (var i = 0, len = imageComponents.length; i < len; i++) {
        imageComponents[i].parentNode.classList.add('col-image');
    }
};
